import { Typography } from '@material-ui/core';

import styles from './DispatchedTypography.module.scss';

const DispatchedTypography = () => <Typography className={styles.label}>Dispatched</Typography>;

export default DispatchedTypography;
